import { render } from "./DeleteEvent.vue?vue&type=template&id=72eb0860&scoped=true"
import script from "./DeleteEvent.vue?vue&type=script&lang=js"
export * from "./DeleteEvent.vue?vue&type=script&lang=js"

import "./DeleteEvent.vue?vue&type=style&index=0&id=72eb0860&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eb0860"]])

export default __exports__